import React from 'react';
import { motion } from 'framer-motion';
import { 
  Banknote, 
  LineChart, 
  ShieldCheck, 
  Users, 
  Zap,
  Bot,
  BarChart3,
  Clock
} from 'lucide-react';

const benefits = [
  {
    icon: <Banknote className="w-6 h-6 text-orcsys-500" />,
    title: "Réduction des coûts",
    description: "Diminuez vos coûts opérationnels jusqu'à 70% grâce à l'automatisation des tâches répétitives"
  },
  {
    icon: <Clock className="w-6 h-6 text-orcsys-500" />,
    title: "Gain de temps",
    description: "Libérez votre équipe des tâches chronophages pour se concentrer sur la création de valeur"
  },
  {
    icon: <LineChart className="w-6 h-6 text-orcsys-500" />,
    title: "Productivité accrue",
    description: "Augmentez votre productivité avec des processus optimisés et une exécution 24/7"
  },
  {
    icon: <ShieldCheck className="w-6 h-6 text-orcsys-500" />,
    title: "Fiabilité maximale",
    description: "Éliminez les erreurs humaines et assurez une qualité constante dans vos opérations"
  },
  {
    icon: <Bot className="w-6 h-6 text-orcsys-500" />,
    title: "IA avancée",
    description: "Exploitez la puissance de l'IA pour automatiser les tâches complexes et la prise de décision"
  },
  {
    icon: <Users className="w-6 h-6 text-orcsys-500" />,
    title: "Satisfaction client",
    description: "Améliorez l'expérience client grâce à des réponses plus rapides et plus précises"
  },
  {
    icon: <Zap className="w-6 h-6 text-orcsys-500" />,
    title: "Mise en place rapide",
    description: "Déployez des solutions d'automatisation en quelques semaines, pas en mois"
  },
  {
    icon: <BarChart3 className="w-6 h-6 text-orcsys-500" />,
    title: "Données exploitables",
    description: "Obtenez des insights précieux grâce à l'analyse automatisée de vos données"
  }
];

const BenefitsSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="container px-4 mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Pourquoi <span className="text-orcsys-500">automatiser</span> vos processus ?
              </h2>
              <p className="text-lg text-slate-600 max-w-3xl mx-auto">
                Découvrez comment l'automatisation et l'IA peuvent transformer votre entreprise 
                en réduisant les coûts et en augmentant l'efficacité opérationnelle.
              </p>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-orcsys-50 flex items-center justify-center mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection; 